import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function CheckVerificationModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const createAccount = () => {
    closeModal(MODALS_ID.CHECK_VERIFICATION)
    navigate('/personalInfo/phone')
  }

  return (
    <Modal id={MODALS_ID.CHECK_VERIFICATION}>
      <Content>
        <Text size={16} weight={500} $textAlign="center" $wordBreak="keep-all">
          본인 인증 후 계좌 개설이 가능해요.
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="primary" onClick={createAccount}>
          본인 인증하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`
